import { Image as WebCommonImage } from '@goat/web-common'
import { ComponentType } from 'react'
import { SpinnerIcon } from 'shared/components/Spinner'
import styled from 'styled-components'

interface IImageProps {
  alt: string
  className?: string
  crop?: boolean
  disableLazyLoad?: boolean
  onClick?: () => void
  onError?: () => void
  onLoad?: () => void
  noSrcModification?: boolean
  resizeable?: boolean
  sizes: string
  src: string
  loader?: ComponentType
}

const Image = ({ loader, ...props }: IImageProps) => {
  return <StyledImage loader={loader ? loader : SpinnerIcon} {...props} />
}

// Styles from 3rd party libs aren't
// making it into the SSR
// adding them back here but
// we will need to address
const StyledImage = styled(WebCommonImage)`
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`

export default Image
